import {createRandomArray, createOrder} from '../moduls/utils.js';

const QUESTIONS_NUMBER = 6;

const questionsArray = createRandomArray(QUESTIONS_NUMBER);

const GAME_1 = [{
  id: 1,
  start: '1',
  steps: {
    'start': {
      type: 'comment',
      imageSrc: './assets/photo/start.jpg',
      imageAuthor: ``,
      comment: `<div>
        <h2>КАК ПОЛУЧИТЬ ПОДДЕРЖКУ ОТ ГОСУДАРСТВА</h2>
        <p>Помоги российским гражданам правильно оформить и рассчитать пособия, льготы и социальные выплаты ФСС РФ</p>
        <p>Предлагаем вашему вниманию, уважаемые читатели, интерактивный онлайн-тьюториал – учебное пособие, которое подскажет, как получить социальную помощь, грамотно и эффективно реализовать свои права и льготы.</p>
        <p>Для этого приглашаем вас пройти 6 уроков.</p>
      </div>`,
      description: `
        <style>.question-counter{display:none}</style>
        <p>Россия – большая и полная чудес, сотворенных природой, страна. Высокие горы Кавказа, снежные просторы тундры и жаркий песок берегов моря – все это наше достояние. С каждым годом мест, где еще не ступала нога человека, становится все меньше, но в России есть уголки, которые сохранили свое естество, заповедные территории, где тщательно оберегается все буйство флоры и фауны для будущих поколений. На развитие этих прекрасных мест направлен один из важнейших федеральных проектов Минприроды «Сохранение биологического разнообразия и развитие экологического туризма». А вы знаете об этих заповедниках? Давайте проверим, сможете ли вы угадать, про какую страну идет речь?</p>`,
      specialClass: 'content__step_start',
      button: true,
      buttonText: 'Пройти 6 уроков',
      next: '1',
    },
    '1': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-1.jpg',
      imageAuthor: ``,
      description: `<p>Теплое летнее утро, розово улыбаясь, в окно заглядывает солнышко… А вам холодно и грустно, и болит горло, и на градуснике 37,8. Вы позвонили врачу и рассказали о своих симптомах. Врач посоветовал отказаться от мысли идти на работу – возможно, у вас вирусная инфекция. Ох, столько всего нужно сделать! Позвонить в офис и предупредить… и да! оформить больничный. Как это лучше сделать?</p>`,
      answers: [
        {
          title: 'Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.',
          next: '1a'
        },
        {
          title: 'Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.',
          next: '1b'
        },
        {
          title: 'Оформлю электронный больничный.',
          next: '1c'
        },
      ],
    },
    '1a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1a.jpg',
      imageAuthor: ``,
      comment: `<p>Теплое летнее утро, розово улыбаясь, в окно заглядывает солнышко… А вам холодно и грустно, и болит горло, и на градуснике 37,8. Вы позвонили врачу и рассказали о своих симптомах. Врач посоветовал отказаться от мысли идти на работу – возможно, у вас вирусная инфекция. Ох, столько всего нужно сделать! Позвонить в офис и предупредить… и да! оформить больничный. Как это лучше сделать?</p>`,
      answerList: [
        ['Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.', 'selected'],
        ['Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.', false],
        ['Оформлю электронный больничный.', false]],
      description: `<p>Конечно, можно и так. Но бумажный документ возможно по неосторожности помять, порвать, чем-то залить, да еще случайно потерять. А если бумажный листок нетрудоспособности затеряется у нерадивого бухгалтера?</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      // next: '1'
      // next: 'finish',
      next: '1',
    },
    '1b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1b.jpg',
      imageAuthor: ``,
      comment: `<p>Теплое летнее утро, розово улыбаясь, в окно заглядывает солнышко… А вам холодно и грустно, и болит горло, и на градуснике 37,8. Вы позвонили врачу и рассказали о своих симптомах. Врач посоветовал отказаться от мысли идти на работу – возможно, у вас вирусная инфекция. Ох, столько всего нужно сделать! Позвонить в офис и предупредить… и да! оформить больничный. Как это лучше сделать?</p>`,
      answerList: [
        ['Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.', false],
        ['Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.', 'selected'],
        ['Оформлю электронный больничный.', false]],
      description: `<p>Не стыдно? А вы знаете, что любая подделка больничного листа наказуема?</p>
      `,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '1',
    },
    '1c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1c.jpg',
      imageAuthor: ``,
      comment: `<p>Теплое летнее утро, розово улыбаясь, в окно заглядывает солнышко… А вам холодно и грустно, и болит горло, и на градуснике 37,8. Вы позвонили врачу и рассказали о своих симптомах. Врач посоветовал отказаться от мысли идти на работу – возможно, у вас вирусная инфекция. Ох, столько всего нужно сделать! Позвонить в офис и предупредить… и да! оформить больничный. Как это лучше сделать?</p>`,
      answerList: [
        ['Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.', false],
        ['Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.', false],
        ['Оформлю электронный больничный.', 'selected']],
      description: `<p>Хорошее решение! Сегодня каждый работающий гражданин может оформить листок нетрудоспособности в электронном виде, причем уже при устройстве на работу уведомить компанию о предпочтительном способе получения выплат из Фонда соцстраха.</p>
      `,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2',
    },
    '2': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-2.jpg',
      imageAuthor: ``,
      description: `<p>Молодая семья Пешковых − сотрудников нижегородской строительной фирмы − готовится к пополнению. Радостное событие еще впереди, и будущая мама уже сейчас, на раннем сроке беременности, встала на учет в женскую консультацию. Но коронакризис заметно пошатнул все планы – компания сократила ряд проектов и частично перешла на дистанционную форму работы, зарплаты уменьшились. Пешковы «самоизолировались» за городом и задались вопросом –  в какой срок теперь можно будет получить пособия?</p>`,
      answers: [
        {
          title: 'Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.',
          next: '2a'
        },
        {
          title: 'Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!',
          next: '2b'
        },
        {
          title: 'По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.',
          next: '2c'
        },
      ],
    },
    '2a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2a.jpg',
      imageAuthor: ``,
      comment: `<p>Молодая семья Пешковых − сотрудников нижегородской строительной фирмы − готовится к пополнению. Радостное событие еще впереди, и будущая мама уже сейчас, на раннем сроке беременности, встала на учет в женскую консультацию. Но коронакризис заметно пошатнул все планы – компания сократила ряд проектов и частично перешла на дистанционную форму работы, зарплаты уменьшились. Пешковы «самоизолировались» за городом и задались вопросом –  в какой срок теперь можно будет получить пособия?</p>`,
      answerList: [
        ['Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.', 'selected'],
        ['Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!', false],
        ['По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.', false],
      ],
      description: `<p>Что значит − повезло или не повезло? Все официально трудоустроенные граждане РФ застрахованы в ФСС РФ и имеют право на получение пособия из средств Фонда.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '2'
    },
    '2b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2b.jpg',
      imageAuthor: ``,
      comment: `<p>Молодая семья Пешковых − сотрудников нижегородской строительной фирмы − готовится к пополнению. Радостное событие еще впереди, и будущая мама уже сейчас, на раннем сроке беременности, встала на учет в женскую консультацию. Но коронакризис заметно пошатнул все планы – компания сократила ряд проектов и частично перешла на дистанционную форму работы, зарплаты уменьшились. Пешковы «самоизолировались» за городом и задались вопросом –  в какой срок теперь можно будет получить пособия?</p>`,
      answerList: [
        ['Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.', false],
        ['Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!', 'selected'],
        ['По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.', false],
      ],
      description: `<p>Вы упустили существенную информацию в условиях задачи: Пешковы – из Нижнего Новгорода, где еще в 2011 году  стартовал проект ФСС РФ «Прямые выплаты», созданный как раз для того, чтобы исключить задержки выплат, возможные при старом порядке начисления пособий.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '2'
    },
    '2c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2c.jpg',
      imageAuthor: ``,
      comment: `<p>Молодая семья Пешковых − сотрудников нижегородской строительной фирмы − готовится к пополнению. Радостное событие еще впереди, и будущая мама уже сейчас, на раннем сроке беременности, встала на учет в женскую консультацию. Но коронакризис заметно пошатнул все планы – компания сократила ряд проектов и частично перешла на дистанционную форму работы, зарплаты уменьшились. Пешковы «самоизолировались» за городом и задались вопросом –  в какой срок теперь можно будет получить пособия?</p>`,
      answerList: [
        ['Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.', false],
        ['Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!', false],
        ['По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.', 'selected']
      ],
      description: `<p>Совершенно верно! В течение 5 календарных дней после подачи Пешковыми заявления их работодатель из Нижнего Новгорода должен передать сведения о работнике в территориальный Фонд, откуда застрахованному лицу напрямую и поступят положенные средства.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3'
    },
    '3': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-3.jpg',
      imageAuthor: ``,
      description: `<p>Экономический коронакризис может повлечь за собой, по мнению СМИ, бум банкротств.  Кто же будет выплачивать семье Пешковых из Нижнего Новгорода декретные пособия, если их компания будет ликвидирована?</p>`,
      answers: [
        {
          title: 'Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!',
          next: '3a'
        },
        {
          title: 'Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!',
          next: '3b'
        },
        {
          title: 'Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.',
          next: '3c'
        },
      ],
    },
    '3a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3a.jpg',
      imageAuthor: ``,
      comment: `<p>Экономический коронакризис может повлечь за собой, по мнению СМИ, бум банкротств.  Кто же будет выплачивать семье Пешковых из Нижнего Новгорода декретные пособия, если их компания будет ликвидирована?</p>`,
      answerList: [
        ['Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!', 'selected'],
        ['Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!', false],
        ['Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.', false],
      ],
      description: `<p>Изучите информацию по теме <a href="https://www.mk.ru/social/2020/11/06/kto-vyplatit-detskie-posobiya-esli-rabotodatel-bankrot.html" target="_blank">«Если работодатель – банкрот»</a> на нашем сайте, а также обратитесь на сайт ФСС РФ в раздел «Государственные услуги».</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '3'
    },
    '3b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3b.jpg',
      imageAuthor: ``,
      comment: `<p>Экономический коронакризис может повлечь за собой, по мнению СМИ, бум банкротств.  Кто же будет выплачивать семье Пешковых из Нижнего Новгорода декретные пособия, если их компания будет ликвидирована?</p>`,
      answerList: [
        ['Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!', false],
        ['Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!', 'selected'],
        ['Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.', false],
      ],
      description: `<p>А ведь неплохой совет! Если предприятие работает и имеет необходимые средства, а выплаты не поступают, то работник может обратиться в необходимые инстанции. А если работодатель – банкрот?</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '3'
    },
    '3c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3c.jpg',
      imageAuthor: ``,
      comment: `<p>Экономический коронакризис может повлечь за собой, по мнению СМИ, бум банкротств.  Кто же будет выплачивать семье Пешковых из Нижнего Новгорода декретные пособия, если их компания будет ликвидирована?</p>`,
      answerList: [
        ['Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!', false],
        ['Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!', false],
        ['Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.', 'selected'],
      ],
      description: `<p>Отличное решение! <a href="https://www.mk.ru/social/2020/11/06/pryamye-vyplaty-shagayut-po-rossii.html" target="_blank">Вот подборка материалов</a>, которые помогут семье Пешковых грамотно и оперативно получить пособия.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '4'
    },
    '4': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-4.jpg',
      imageAuthor: ``,
      description: `<p>Помните фильм «Дети Дон Кихота»? В семье прекрасного врача Петра Бондаренко трое сыновей. Виктор и Дмитрий уже взрослые, Юра − школьник. Вскоре в доме появится четвертый ребенок – совсем малыш. Перенесем ситуацию в 2020 год и поможем герою Анатолия Папанова правильно рассчитать размер ежемесячного детского пособия!  </p>`,
      answers: [
        {
          title: 'Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.',
          next: '4a'
        },
        {
          title: 'Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.',
          next: '4b'
        },
        {
          title: 'Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.',
          next: '4c'
        },
      ],
    },
    '4a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4a.jpg',
      imageAuthor: ``,
      comment: `<p>Помните фильм «Дети Дон Кихота»? В семье прекрасного врача Петра Бондаренко трое сыновей. Виктор и Дмитрий уже взрослые, Юра − школьник. Вскоре в доме появится четвертый ребенок – совсем малыш. Перенесем ситуацию в 2020 год и поможем герою Анатолия Папанова правильно рассчитать размер ежемесячного детского пособия!  </p>`,
      answerList: [
        ['Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.', 'selected'],
        ['Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.', false],
        ['Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.', false],
      ],
      description: `<p>Некорректный совет. Во-первых, отпуск по уходу за ребенком может оформить и отец семейства. Во-вторых, правильный предварительный расчет сегодня каждый может сделать сам, обратившись, например, на сайт ФСС РФ</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '4'
    },
    '4b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4b.jpg',
      imageAuthor: ``,
      comment: `<p>Помните фильм «Дети Дон Кихота»? В семье прекрасного врача Петра Бондаренко трое сыновей. Виктор и Дмитрий уже взрослые, Юра − школьник. Вскоре в доме появится четвертый ребенок – совсем малыш. Перенесем ситуацию в 2020 год и поможем герою Анатолия Папанова правильно рассчитать размер ежемесячного детского пособия!</p>`,
      answerList: [
        ['Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.', false],
        ['Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.', 'selected'],
        ['Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.', false],
      ],
      description: `<p>Именно так! По закону отпуск по уходу за малышом может оформить не только его мама, но и папа, а также дедушка и бабушка и другие работающие родственники. Но все же, в условии задачи, нам нужно сделать именно расчет.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '4'
    },
    '4c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4c.jpg',
      imageAuthor: ``,
      comment: `<p>Помните фильм «Дети Дон Кихота»? В семье прекрасного врача Петра Бондаренко трое сыновей. Виктор и Дмитрий уже взрослые, Юра − школьник. Вскоре в доме появится четвертый ребенок – совсем малыш. Перенесем ситуацию в 2020 год и поможем герою Анатолия Папанова правильно рассчитать размер ежемесячного детского пособия!  </p>`,
      answerList: [
        ['Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.', false],
        ['Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.', false],
        ['Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.', 'selected'],
      ],
      description: `<p>Приведем пример правильного расчета. Пусть Вера Бондаренко за 2018 и 2019 годы заработала 1 070 000 рублей. Соответственно, ее среднемесячная зарплата составила 44558,8 рубля (1070000/730*30,4). Таким образом, в отпуске по уходу за ребенком до 1,5 года она будет получать 40% от своего среднего заработка, то есть чуть более 17823,52 рубля.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '5'
    },
    '5': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-5.jpg',
      imageAuthor: ``,
      description: `<p>Как вы считаете, какой сегодня самый удобный способ получить пособие из средств Фонда соцстраха  для беременных женщин и семей с детьми?</p>`,
      answers: [
        {
          title: 'Конечно, наличными!',
          next: '5a'
        },
        {
          title: 'Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.',
          next: '5b'
        },
        {
          title: 'Карта «МИР».',
          next: '5c'
        },
      ],
    },
    '5a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5a.jpg',
      imageAuthor: ``,
      comment: `<p>Как вы считаете, какой сегодня самый удобный способ получить пособие из средств Фонда соцстраха  для беременных женщин и семей с детьми?</p>`,
      answerList: [
        ['Конечно, наличными!', 'selected'],
        ['Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.', false],
        ['Карта «МИР».', false],
      ],
      description: `<p>Если ваш регион еще не подключился к «Прямым выплатам», то получить пособия можно в кассе работодателя. А если предприятие ликвидируется?</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '5'
    },
    '5b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5b.jpg',
      imageAuthor: ``,
      comment: `<p>Как вы считаете, какой сегодня самый удобный способ получить пособие из средств Фонда соцстраха  для беременных женщин и семей с детьми?</p>`,
      answerList: [
        ['Конечно, наличными!', false],
        ['Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.', 'selected'],
        ['Карта «МИР».', false],
      ],
      description: `<p>Перечислить на ваш счет в банке и в отделение почты по месту жительства может как работодатель, так и Фонд социального страхования (в регионах с «Прямыми выплатами»). Но так ли это быстро и удобно?</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '5'
    },
    '5c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5c.jpg',
      imageAuthor: ``,
      comment: `<p>Как вы считаете, какой сегодня самый удобный способ получить пособие из средств Фонда соцстраха  для беременных женщин и семей с детьми?</p>`,
      answerList: [
        ['Конечно, наличными!', false],
        ['Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.', false],
        ['Карта «МИР».', 'selected'],
      ],
      description: `<p>Да, в регионах, где действует механизм «Прямые выплаты», для получения выплат на карту «МИР» достаточно указать лишь номер карты, и деньги появятся максимум через 30 минут после их перечисления из ФСС.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '6'
    },
    '6': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-6.jpg',
      imageAuthor: ``,
      description: `<p>Помните капитана Копейкина из гоголевских «Мертвых душ», который, став инвалидом на войне 1812 года, так и не получил никакой помощи от равнодушных чиновников? Конечно, и в ХХI веке никто не застрахован от профессиональных заболеваний или несчастных случаев на производстве. Но в действующей сегодня в РФ системе социального страхования – как раз застрахован! Пострадавшим работникам гарантирована материальная помощь от государства. Итак, какие меры поддержки предусмотрены Фондом соцстраха РФ при утрате трудоспособности?</p>`,
      answers: [
        {
          title: 'Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.',
          next: '6a'
        },
        {
          title: 'Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.',
          next: '6b'
        },
        {
          title: 'Пострадавшему назначается пожизненная ежемесячная страховая выплата.',
          next: '6c'
        },
      ],
    },
    '6a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6a.jpg',
      imageAuthor: ``,
      comment: `<p>Помните капитана Копейкина из гоголевских «Мертвых душ», который, став инвалидом на войне 1812 года, так и не получил никакой помощи от равнодушных чиновников? Конечно, и в ХХI веке никто не застрахован от профессиональных заболеваний или несчастных случаев на производстве. Но в действующей сегодня в РФ системе социального страхования – как раз застрахован! Пострадавшим работникам гарантирована материальная помощь от государства. Итак, какие меры поддержки предусмотрены Фондом соцстраха РФ при утрате трудоспособности?</p>`,
      answerList: [
        ['Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.', 'selected'],
        ['Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.', false],
        ['Пострадавшему назначается пожизненная ежемесячная страховая выплата.', false],
      ],
      description: `<p>Такой ответ может ввести человека в заблуждение. Изучите материал более внимательно.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '6'
    },
    '6b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6b.jpg',
      imageAuthor: ``,
      comment: `<p>Помните капитана Копейкина из гоголевских «Мертвых душ», который, став инвалидом на войне 1812 года, так и не получил никакой помощи от равнодушных чиновников? Конечно, и в ХХI веке никто не застрахован от профессиональных заболеваний или несчастных случаев на производстве. Но в действующей сегодня в РФ системе социального страхования – как раз застрахован! Пострадавшим работникам гарантирована материальная помощь от государства. Итак, какие меры поддержки предусмотрены Фондом соцстраха РФ при утрате трудоспособности?</p>`,
      answerList: [
        ['Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.', false],
        ['Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.', 'selected'],
        ['Пострадавшему назначается пожизненная ежемесячная страховая выплата.', false],
      ],
      description: `<p>Верно, но не только. Производится также единовременная выплата от Фонда. Эта выплата зависит от процента повреждения здоровья. При 100% утрате здоровья единовременная выплата с 01.02.2020 составляет 103 527,66 рубля.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: 'finish'
    },
    '6c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6с.jpg',
      imageAuthor: ``,
      comment: `<p>Помните капитана Копейкина из гоголевских «Мертвых душ», который, став инвалидом на войне 1812 года, так и не получил никакой помощи от равнодушных чиновников? Конечно, и в ХХI веке никто не застрахован от профессиональных заболеваний или несчастных случаев на производстве. Но в действующей сегодня в РФ системе социального страхования – как раз застрахован! Пострадавшим работникам гарантирована материальная помощь от государства. Итак, какие меры поддержки предусмотрены Фондом соцстраха РФ при утрате трудоспособности?</p>`,
      answerList: [
        ['Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.', false],
        ['Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.', false],
        ['Пострадавшему назначается пожизненная ежемесячная страховая выплата.', 'selected'],
      ],
      description: `<p>Не совсем так. Помимо выплат по больничному листу и единовременной выплаты из Фонда пострадавшему назначается ежемесячная страховая выплата. Он ее может получать до момента полного выздоровления. Если выздоровления не произошло, выплата производится пожизненно, но не наследуется.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '6'
    },
    'finish': {
      type: 'comment',
      imageSrc: './assets/photo/final.jpg',
      imageAuthor: '',
      comment: `
        <style>.content__answer-list{display:none}.last__bottom-link{text-align:center;margin-bottom:20px;color:#333;font-size:16px;font-weight:400}</style>
        <p>Поздравляем! Вы хорошо ориентируетесь в вопросах обязательного социального страхования граждан Российской Федерации и можете помочь людям в сложных жизненных ситуациях.</p>`,
      button: true,
      buttonText: 'Играть с начала',
      shareButton: {classNames: {mainWraper: 'last__share', linkItem: 'last__share-button'}},
      endingScreen: true,
      specialClass: 'content__step_finish',
      next: '1',
      textAfter: `
        <div class="text-after">
          <ul class="text-after__list">
            <li class="text-after__item">
              <a href="http://fss.ru" target="_blank" rel="noopener">
                <span class="text-after__item-text">Более подробно читайте на fss.ru</span>
              </a>
            </li>
            <li class="text-after__item">
              <a href="https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/#experts" target="_blank" rel="noopener">
                <span class="text-after__item-text">Колонка экспертов</span>
              </a>
            </li>
            <li class="text-after__item">
              <a href="https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/#consultation" target="_blank" rel="noopener">
                <span class="text-after__item-text">Онлайн консультация</span>
              </a>
            </li>
            <li class="text-after__item">
              <a href="https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/#gosuslugi" target="_blank" rel="noopener">
                <span class="text-after__item-text">О государственных услугах фонда</span>
              </a>
            </li>
          </ul>
        </div>
      `,
    }
  }
}];

createOrder(GAME_1[0].steps, QUESTIONS_NUMBER, questionsArray);

export const jsonAnswerMock1 = JSON.stringify(GAME_1);



// WEBPACK FOOTER //
// ./data/get-mock-data.js